import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/api/login", params) };
// 策略列表
export const celueExplain = (params) => { return req("post", "/api/get_celue_explain", params) };
export const celueExplain2 = (params) => { return req("post", "/api/get_celue_explain2", params) };
//获取当日策略表
export const getToday = (params) => { return req("post", "/api/get_today_data", params) };
//当日多策略选股交集
export const getDatas = (params) => { return req("post", "/api/get_today_datas", params) };
//历史得分
export const getHistory=(params)=>{ return req("post",'/api/get_stock_his',params)}
//编辑
export const editIll=(params)=>{return req('post',"/api/edit_celue_explain",params)}
//获取用户列表
export const userList=(params)=>{return req('post',"/api/get_users",params)}
//新增用户
export const addUser=(params)=>{return req('post',"/api/add_user",params)}
//修改密码
export const upUser=(params)=>{return req('post',"/api/update_psd",params)}
//删除用户
export const delUser=(params)=>{return req('post',"/api/del_user",params)}
//股票代码查询接口
export const search11=(params)=>{return req('post',"/api/stock_search",params)}
// 250天记录查询接口
export const query11=(params)=>{return req('post',"/api/stock_250_query",params)}
//
export const query22=(params)=>{return req('post',"/api/stock_a_query",params)}
//
export const historyQuery = (params)=>{return req('post','/api/stock_search_all',params)}
export const filter_bdd = (params)=>{return req('post','/api/filter_bdd',params)}



// WEBPACK FOOTER //
// ./src/api/userMG.js